import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
const data = [{
  name: 'Materialer',
  value: 92000
}, {
  name: 'Arbejdsløn',
  value: 38000
}, {
  name: 'Øvrigt',
  value: 16400
}, {
  name: 'Fragt',
  value: 4800
}];
const total = data.reduce((acc, item) => acc + item.value, 0);
const colors = ['#3b82f6', '#6366f1', '#8b5cf6', '#a3a3a3'];
export function CostDistribution() {
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-id="element-6">
      <h3 className="text-lg font-medium text-gray-800" data-id="element-7">
        Omkostningsfordeling
      </h3>
      <div className="h-64 mt-4" data-id="element-8">
        <ResponsiveContainer width="100%" height="100%" data-id="element-9">
          <BarChart layout="vertical" data={data} margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 10
        }} data-id="element-10">
            <XAxis type="number" hide data-id="element-11" />
            <YAxis type="category" dataKey="name" hide data-id="element-12" />
            <Tooltip formatter={value => [`${value.toLocaleString('da-DK')} kr`, 'Beløb']} labelFormatter={name => name} contentStyle={{
            borderRadius: '0.5rem',
            border: '1px solid #e5e7eb'
          }} data-id="element-13" />
            <Bar dataKey="value" radius={[4, 4, 4, 4]} barSize={24} data-id="element-14">
              {data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} data-id="element-15" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-4" data-id="element-16">
        {data.map((item, index) => <div key={index} className="flex items-center" data-id="element-17">
            <div className="w-3 h-3 rounded-sm mr-2" style={{
          backgroundColor: colors[index % colors.length]
        }} data-id="element-18"></div>
            <div data-id="element-19">
              <div className="text-sm font-medium" data-id="element-20">{item.name}</div>
              <div className="text-xs text-gray-500" data-id="element-21">
                {item.value.toLocaleString('da-DK')} kr (
                {(item.value / total * 100).toFixed(1)}%)
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}